import axios from "axios";

const API = axios.create({
  baseURL: "https://www.careplus.gopillz.com",
});

// ✅ Attach token automatically
API.interceptors.request.use((config) => {
  const token = localStorage.getItem("token");

  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }

  return config;
});

// ✅ Handle auth error globally
API.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      // 🔥 Token expired / invalid
      localStorage.removeItem("token");
      localStorage.removeItem("login");

      alert("Session expired. Please login again.");
      console.error("Authentication error:", error);

      window.location.href = "/login";
    }

    if (error.response?.status === 403) {
      // 🔥 Token expired / invalid
      localStorage.removeItem("token");
       localStorage.removeItem("login");

      alert("Session expired. Please login again.");

      window.location.href = "/login";
    }

    return Promise.reject(error);
  }
);

export default API;